<template>

    <trax-ui-ajax-table-with-crud-actions id="trax-account-basic-client" 
        :titles="titles" :props="props" :endpoint="endpoint" :bus="bus">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: ['bus'],

        data: function() {
            return {
                endpoint: app_url+"trax/ajax/account/basic-clients",
                titles: [
                    lang.polaris.form.name,
                    lang.polaris.account.username,
                    lang.polaris.account.password,
                    ''
                ],
                props: [
                    {source: 'data.name'},
                    {source: 'username'},
                    {source: 'password'}
                ]
            }
        }
    }
</script>
